import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  isLoading = false;
  isSubmitted = false;
  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
  }
  
  onSignup(form: NgForm) {
    if(form.invalid) {
      return;
    }
    //console.log(form);
    this.isLoading = true;
    this.isSubmitted = true;
    this.userService.signup(form.value).subscribe((response) => {
      form.reset();
    });
  }
}